module.exports = __webpack_public_path__ + "img/daesung.b88b7a5d.svg";